import './styles';

import React, { useState, useEffect } from 'react';

import { formatThousands } from 'shared/number_helper';

const BADGE_SIZE_SMALL = 120; // Same as $size-badge-small
const BADGE_SIZE_BIG = 200; // Same as $size-badge
const MQ_BREAKPOINT = 860; // Same as medium breakpoint in Sass
const Badge = props => {
    /* NOTE: This is matching the logic we have in the actual badge's
     * `textContent` property that checks whether there is any
     * metrics given and if not it replaces the score by a
     * question mark (cf. packages/embed/badge.js).*/
    const score =
        props.totalCitations === undefined || props.totalCitations === null
            ? '?'
            : formatThousands(props.totalCitations);

    let mq = window.matchMedia(`(min-width: ${MQ_BREAKPOINT}px)`);
    const getSize = matches => (matches ? BADGE_SIZE_BIG : BADGE_SIZE_SMALL);
    const sizeHandler = e => {
        setSize(getSize(e.currentTarget.matches));
    };
    const [size, setSize] = useState(getSize(mq.matches));
    const addListener = () => {
        if (mq.addEventListener) {
            mq.addEventListener('change', sizeHandler);
        } else {
            mq.addListener(sizeHandler);
        }
    };
    const removeListener = () => {
        if (mq.removeEventListener) {
            mq.removeEventListener('change', handler);
        } else {
            mq.removeListener(handler);
        }
    };
    useEffect(() => {
        addListener();
        return () => {
            removeListener();
        };
    }, []);

    const badgeSVGURL = `${props.config.badgeServerURL}/badge?count=${score}&size=${size}&background=fill&format=svg`;
    const badgePNGURL = `${props.config.badgeServerURL}/badge?count=${score}&size=${size}&background=fill`;

    const style = {
        backgroundImage: `url(${badgeSVGURL})`
    };

    return (
        <div className="Badge" style={style}>
            <img
                src={badgePNGURL}
                alt={I18n.t('badge_logo', {
                    formattedCount: score,
                    count: props.totalCitations
                })}
            />
        </div>
    );
};

export default Badge;
